import Vue from "vue";
import App from "./App.vue";
import Amplify from "aws-amplify";
import "@aws-amplify/ui-vue";
import aws_exports from "./aws-exports";
import VueRouter from "vue-router";
import { routes } from "./routes";

Amplify.configure(aws_exports);
Vue.use(VueRouter);

import { LMap, LTileLayer, LCircle, LMarker, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css"; // Re-uses images from ~leaflet package

import "leaflet-defaulticon-compatibility";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
Vue.component("v-marker-cluster", Vue2LeafletMarkerCluster);

import VueFusionCharts from 'vue-fusioncharts';

// import FusionCharts modules and resolve dependency
import FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/fusioncharts.timeseries';
import Column2D from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
Vue.use(VueFusionCharts, FusionCharts, Column2D, TimeSeries, FusionTheme);


FusionCharts.options.license({
  key: 'PtB2dF-7wB4C5C3D5G4E3A2J4B10A7D2B3F6tgoD3B1d1fdzoG4I3I-7jD-17A3D5B3D5D4B3B3C3D7D7C2C4G5G1D2G1rmoE6E1C4gI4B3C8zyhD3D2E3vraA4B2C2zbnD1H4B3A5B3F4F3H3G4A19A32aikC6D3RH4moA-31A7C8A3wfA2IC1C5rA-16mD2D5F1A2B2B7C4D6A3A1E4E2C2C3u==',
  creditLabel: false,
});

import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)

import vuetify from "./plugins/vuetify";

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// import VueApexCharts from "vue-apexcharts";
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);

import Chartkick from "vue-chartkick";
import Chart from "chart.js";
Vue.use(Chartkick.use(Chart));

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-circle", LCircle);
Vue.component("l-tooltip", LTooltip); 

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
});

// router.beforeEach((to, from, next) => {
//   // console.log("Router Before Each", to, from, next);

//   Auth.currentAuthenticatedUser().then(authData => {
//     console.log('router beforeEach authData', authData);
//   });
//   var authState = 'signedout';
//   var authExists = true;
//   if(authExists){
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       // this route requires auth, check if logged in
//       // if not, redirect to login page.
//       if (authState != 'signedin') {
//         next({
//           path: '',
//           // query: { redirect: to.Landing }
//         })
//       } else {
//         next()
//       }
//     } else {
//       next() // make sure to always call next()!
//     }
//   }
//   else{
//     next({
//       path: "/",
//     })
//   }
// })

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
